import { useQuery } from "@tanstack/react-query";
import {
  OrderAdditionalDetailsClient,
  OrderRelatedDataDto,
} from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";
import type { OrderDrawerIdentifier } from "./types";

interface UseOrderAdditionalDetailsOptions {
  identifier: OrderDrawerIdentifier | null;
  enabled: boolean;
}

export function useOrderAdditionalDetails({
  identifier,
  enabled,
}: UseOrderAdditionalDetailsOptions) {
  const api = useApi(OrderAdditionalDetailsClient);

  const biOrderId = identifier?.biOrderId;
  const canFetch = enabled && !!biOrderId && biOrderId > 0;

  const query = useQuery({
    queryKey: ["order-drawer-additional-details", biOrderId ?? null],
    queryFn: async (): Promise<OrderRelatedDataDto[]> => {
      if (!biOrderId || biOrderId <= 0) {
        return [];
      }
      return api.getByBiOrderId(biOrderId);
    },
    enabled: canFetch,
    retry: 1,
    staleTime: 5 * 60 * 1000,
  });

  return {
    additionalDetails: query.data ?? [],
    isLoading: query.isFetching,
    isError: query.isError,
  };
}
